module.exports = __webpack_public_path__ + "static/media/tic_tac_chat.1b7a2554.png";